import "./index.scss";
import {
  CheckoutSummary,
  CheckoutHeader,
  CheckoutPayment
} from "components/UI/organisms";
import { useHideElements } from "hooks/useHideElements";
import { NavLink } from "hooks/useCustomNavigation";
import { CheckoutCopyright, CheckoutMobileSteps } from "components/UI/atoms";
import { ReactHelmetWithProvider } from "providers/ReactHelmetProvider";
import { useWindowDimensions } from "hooks/useWindowDimensions";
import { Breadcrumb, FallbackLoader } from "components/UI/molecules";
import { EXTERNAL_LINKS, INTERNAL_PATHS } from "routes/paths";
import { useCheckoutContext } from "context/checkout-context";

export const Checkout = () => {
  const { isLoading } = useCheckoutContext();
  const { width } = useWindowDimensions();
  const isDesktop = width >= 768;

  const HIDDEN_ELEMENTS = [".navbar-header", "footer"];
  useHideElements(HIDDEN_ELEMENTS);

  return (
    <div className="checkout">
      <ReactHelmetWithProvider>
        <title>GCX: Checkout</title>
        <meta name="robots" content="noindex" />
      </ReactHelmetWithProvider>
      <CheckoutHeader step={2} />
      <CheckoutMobileSteps />
      {isLoading ? (
        <FallbackLoader />
      ) : (
        <>
          {isDesktop && (
            <Breadcrumb
              rightSide={
                <NavLink to={EXTERNAL_LINKS.MARKETPLACE_ZENDESK}>
                  Email Us
                </NavLink>
              }
              list={[
                {
                  label: "< Continue Shopping",
                  linkTo: INTERNAL_PATHS.BUY_GIFT_CARDS
                }
              ]}
            />
          )}
          <main className="checkout-area">
            <div className="checkout-payment-area">
              <h1 className="checkout-title">Secure Checkout</h1>
              <CheckoutPayment />
              <CheckoutCopyright customClassName="copyright-checkout-desktop" />
            </div>
            <CheckoutSummary />
          </main>
        </>
      )}
    </div>
  );
};
